export default {
  locale: "en",
  name: "Modificaciones",
  translation: { displayName: "Configure the question" },
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      {
        fieldName: "position",
        displayName: "Order",
      },
      {
        fieldName: "active",
        displayName: "Active",
      },
      {
        fieldName: "ticker",
        displayName: "Identifier",
      },
      {
        fieldName: "widgetType",
        fieldSelector: {
          INPUT: "Free text",
          SELECT: "Drop down",
          STAY_DATE: "Stay Date Selector",
          CHECKBOX: "Checkbox",
          PHONE: "Phone",
        },
        displayName: "Type of Answer",
      },
      {
        fieldName: "required",
        displayName: "Required",
      },
    ],
    form: [
      {
        fieldName: "position",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Active",
        widget: "singleSwitch",
        className: "activeCheckbox",
      },
      {
        fieldName: "ticker",
        displayName: "Identifier",
        widget: "input",
        className: "tickerInput",
      },
      {
        fieldName: "required",
        displayName: "Required",
        widget: "checkbox",
      },
      {
        fieldName: "widgetType",
        displayName: "Type of answer",
        widget: "selector",
        optionDisplay: {
          INPUT: {
            label: "Free text",
          },
          SELECT: {
            label: "Drop down",
          },
          // CHECKBOX: {
          //   label: "Checkbox"
          // },
          STAY_DATE: {
            label: "Stay Date Selector",
          },
          PHONE: {
            label: "phone",
          },
        },
        defaultValue: "INPUT",
      },
      {
        fieldName: "label",
        widget: "input",
        displayName: "Question",
        className: "tickerInput",
        translated: true,
      },
      {
        fieldName: "placeholder",
        widget: "input",
        displayName: "Help information about the field",
        className: "tickerInput",
        translated: true,
      },
      {
        fieldName: "items",
        displayName: "Answer Options",
        placeholder: "option1,option2,option3...",
        widget: "input",
        translated: true,
        visible: ({ formValues }) =>
          formValues.widgetType === "SELECT" || formValues.widgetType === "CHECKBOX",
      },
    ],
  },
};
